import React from 'react';
import Dialog, { DialogProps } from '../../../components/dialog/Dialog';
import { Button } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { enqueueSnackbar } from 'notistack';
import { ApiError } from '../../../shared/types/api-response';
import { SiteDesignStatus, useSiteEditDesignInfoMutation } from '../../../generated/types';

interface UnpublishModalProps extends Omit<DialogProps, 'onClose'> {
    onClose: () => void;
    onSuccess?: () => void;
}

const UnpublishModal: React.FC<UnpublishModalProps> = ({ onClose, onSuccess, ...props }) => {
    const [unPublishSite, { loading }] = useSiteEditDesignInfoMutation();

    const handleUnpublishDesign = async () => {
        await unPublishSite({
            variables: {
                input: {
                    status: SiteDesignStatus.Draft,
                },
            },
            onError: (e: any) => {
                const err = e as ApiError;
                if (err.status === 500) {
                    enqueueSnackbar(`Can not unpublish design. Try again later!`, {
                        variant: 'error',
                    });
                }
            },
            onCompleted() {
                onSuccess && onSuccess();
            },
        });
    };

    return (
        <Dialog {...props} onClose={onClose}>
            <div className="w-full pt-20 px-30 pb-40">
                <p className="text-14 leading-17">
                    Are you sure you want to unpublish your site? It will no longer be visible on the web. You can
                    republish it at any time.
                </p>
                <div className="flex items-center mt-30 -mx-5">
                    <div className={`flex-1 px-5`}>
                        <Button size={`large`} color={`primary`} variant="outlined" fullWidth={true} onClick={onClose}>
                            Cancel
                        </Button>
                    </div>
                    <div className={`flex-1 px-5`}>
                        <LoadingButton
                            size={`large`}
                            color={`primary`}
                            variant={'contained'}
                            fullWidth={true}
                            loading={loading}
                            onClick={() => handleUnpublishDesign()}
                        >
                            Unpublish
                        </LoadingButton>
                    </div>
                </div>
            </div>
        </Dialog>
    );
};

export default UnpublishModal;
